import dayjs from 'dayjs';

// Is dateToCheck today?
export const isItToday = (dateToCheck: string): boolean => {
    const todaysDate = getTodayDate();
    return dayjs(todaysDate).isSame(dateToCheck, 'd');
};

// Returns Today's date, no time
export const getTodayDate = (): Date => {
    return new Date();
};

// Take date in this format: 2022-06-16T08:57:06.000000000Z
// and use the first 7 characters: 2022-06 to identify the year and month
export const getYearAndMonth = (datetime: string) => {
    return datetime.substring(0, 7);
};

// Take date in this format: 2022-06-16T08:57:06.000000000Z
// and use the first 10 characters: 2022-06-16 to identify the day
export const getYearMonthDay = (datetime: string) => {
    return datetime.substring(0, 10);
};

export const getMinutesBetweenDates = (startDate: string, endDate: string) => {
    const startingDate = new Date(startDate);
    const endingDate = new Date(endDate);
    const diffMins = Math.ceil(
        Math.abs(endingDate.getTime() - startingDate.getTime()) / 1000 / 60,
    );
    return diffMins;
};
